import React from 'react';
import { ExerciseDashboard } from '../components/exercise/exerciseDashboard';
import { Header } from '../components/global/header';
import { Footer } from '../components/global/footer';

export function ExerciseDashboardPage() {
  return (
    <div>
      <Header />
      <ExerciseDashboard />
      <Footer />
    </div>
  );
}

export default ExerciseDashboardPage;
